import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";

// ✅ FETCH LIST WITH CACHE
export const fetchUserDonationList = createAsyncThunk(
  "userDonationList/fetchUserDonationList",
  async (
    { page = 1, search = "", fetchAll = false },
    { rejectWithValue, getState }
  ) => {
    try {
      const { userDonationList } = getState();
      const { pageSize, cache } = userDonationList;

      const cacheKey = `${page}_${search}_${pageSize}_${fetchAll}`;

      // ✅ cache check
      if (cache[cacheKey]) {
        return {
          data: cache[cacheKey],
          page,
          search,
          pageSize,
          fromCache: true,
        };
      }

      // ✅ SAME STYLE AS PANEL USER
      let url = `/redeem/panel/donated`;

      if (!fetchAll) {
        url += `?page=${page}&page_size=${pageSize}`;
      } else {
        url += `?page=1&page_size=10000`;
      }

      if (search) {
        url += `&search=${search}`;
      }

      const response = await api.get(url);

      return {
        data: response.data,
        page,
        search,
        pageSize: fetchAll ? 10000 : pageSize,
        fromCache: false,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateUserDonation = createAsyncThunk(
  "userDonationList/updateUserDonation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/redeem/panel/donated`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);




const userDonationSlice = createSlice({
  name: "userDonationList",

  initialState: {
      list: [],
      fullData: [],
    search: "",
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    status: "idle",
    error: null,
    cache: {},
  },

  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.currentPage = 1;
      state.cache = {}; // ✅ reset cache on size change
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.currentPage = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder

      // ✅ FETCH
      .addCase(fetchUserDonationList.pending, (state) => {
        state.status = "loading";
      })

      .addCase(fetchUserDonationList.fulfilled, (state, action) => {
        const { data, page, search, pageSize, fromCache } = action.payload;

          const fetchAll = action.meta.arg.fetchAll || false;

          const cacheKey = `${page}_${search}_${pageSize}_${fetchAll}`;

          if (!fromCache) {
            state.cache[cacheKey] = data;
          }


        state.list = data?.result || [];
         state.fullData = data?.result || [];
        state.currentPage = page;
        state.search = search;
        state.pageSize = pageSize;
        state.totalPages = Math.ceil(
          (data?.pagination?.count || 0) / pageSize
        );
        state.status = "succeeded";
      })

      .addCase(fetchUserDonationList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // ✅ UPDATE
      .addCase(updateUserDonation.pending, (state) => {
        state.status = "loading";
      })

      .addCase(updateUserDonation.fulfilled, (state) => {
        state.status = "succeeded";
        
        // ✅ CLEAR CACHE AFTER UPDATE
        // state.cache = {};
      })

      .addCase(updateUserDonation.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { setPage, setPageSize, setSearch, clearError } = userDonationSlice.actions;
export default userDonationSlice.reducer;